import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ReportButtonGroupComponent } from './report-button-group/report-button-group.component';
import { ReportButtonComponent } from './report-button-group/report-button/report-button.component';
import { IdoModule } from './report-popups/groups/ido/ido-module';
import { ReportPopupsModule } from './report-popups/groups/report-popups.module';
import { SummariesModule } from './report-popups/groups/summaries/summaries.module';
import { ReportsComponent } from './reports.component';
import { ReportsRoutingModule } from './reports.routing.module';

@NgModule({
  declarations: [
    ReportsComponent,
    ReportButtonComponent,
    ReportButtonGroupComponent,
  ],
  exports: [ReportButtonComponent, ReportButtonGroupComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ReportPopupsModule,
    ReportsRoutingModule,
    SummariesModule,
    IdoModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportsModule {}
